import { COMMON_PAGE_LIMIT, prepareIdsForChunking } from '@wix/a11y-wizard-common';
import { queryPrograms } from '@wix/ambassador-achievements-programs-v2-program/http';
import { extractCoverImagesFromPrograms } from './utils';
export const batchFetchOnlineProgramsCoverImages = async (httpClient, errorHandler, ids) => {
  const idChunks = prepareIdsForChunking(ids, COMMON_PAGE_LIMIT);
  const chunkPromises = idChunks.map(idChunk => fetchOnlineProgramsCoverImages(httpClient, errorHandler, idChunk));
  const results = await Promise.allSettled(chunkPromises);
  const allPrograms = results.filter(result => result.status === 'fulfilled').flatMap(result => result.value);
  return extractCoverImagesFromPrograms(allPrograms);
};
export const fetchOnlineProgramsCoverImages = async (httpClient, errorHandler, ids) => {
  const {
    withErrorHandler
  } = errorHandler;
  return withErrorHandler(async () => {
    const allPrograms = [];
    let offset = 0;
    let hasMore = false;
    do {
      const {
        data: {
          programs,
          metadata
        }
      } = await httpClient.request(queryPrograms({
        query: {
          filter: {
            ...(ids.length > 0 ? {
              id: {
                $in: ids
              }
            } : {})
          },
          paging: {
            limit: COMMON_PAGE_LIMIT,
            offset
          }
        }
      }));
      allPrograms.push(...(programs ?? []));
      hasMore = (metadata == null ? void 0 : metadata.hasNext) ?? false;
      offset += COMMON_PAGE_LIMIT;
    } while (hasMore);
    return allPrograms;
  }, {
    errorCodesMap: {}
  });
};
//# sourceMappingURL=fetch-online-programs-cover-images.js.map